// теги которые надо исключить
const EXCLUDED_TAGS = [
    'img', 'figure', 'figcaption', 'abbr', 'button', 'input', 'select', 'textarea', 'form', 'picture', 'source',
    'iframe', 'svg', 'path', 'g', 'rect', 'circle', 'line', 'polyline', 'polygon', 'label', 'datalist', 'output',
    'progress', 'meter', 'details', 'summary', 'ymaps', 'ymap', 'resource', 'script', 'style', 'versioning',
    'refresh', 'refresher', 'wbr', 'noembed', 'canvas', 'noscript', 'noindex', 'noscript',
];

// теги которые не должны быть пустые
const REQUIRED_TAGS = [ 'a' ];

// теги без стилей
const NO_STYLES_TAGS = [ 'a', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6' ];

// запрещённое начало ссылки
const LINK_STARTS_WITHOUT = [ 'javascript:', 'tel:' ];

// теги которые надо заменить на div
const REPLACE_TAGS = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'section', 'dl', 'dt', 'dd', 'nav', 'footer', 'font', 'header',
    'main', 'article', 'aside', 'blockquote', 'details', 'dialog', 'dir', 'menu', 'time', 'slot',
    'template',
];


function replaceWithDefaultElement(element) {
    const newElement = document.createElement('div');
    newElement.innerHTML = sanitizeHtml(element.innerHTML);
    element.replaceWith(newElement);
}


export function sanitizeHtml(html) {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const elements = doc.querySelectorAll('*');

    for (const element of elements) {
        // если в названии тега есть неймпспейс, то убрать его
        if (element.tagName.includes(':')) {
            element.remove();
            continue;
        }

        if (EXCLUDED_TAGS.includes(element.tagName.toLowerCase())) {
            element.remove();
            continue;
        }

        if (REQUIRED_TAGS.includes(element.tagName.toLowerCase())) {
            if (element.innerHTML.trim() === '' || element.innerText.trim() === '') {
                element.remove();
                continue;
            }
        }

        // если ссылка пустая или начинается на LINK_STARTS_WITHOUT, заменить на div
        if (element.tagName.toLowerCase() === 'a') {
            const href = element.getAttribute('href');
            if (!href || LINK_STARTS_WITHOUT.some((start) => href.startsWith(start))) {
                replaceWithDefaultElement(element);
            }
        }

        if (REPLACE_TAGS.includes(element.tagName.toLowerCase())) {
            replaceWithDefaultElement(element);
        }

        if (element.tagName.toLowerCase().includes('-')) {
            replaceWithDefaultElement(element);
        }

        const href = element.getAttribute('href');
        const src = element.getAttribute('src');
        const textAlign = element.style.textAlign;

        while (element.attributes.length > 0) {
            element.removeAttributeNode(element.attributes[0]);
        }
        element.style.cssText = '';

        if (href) element.setAttribute('href', href);
        if (src) element.setAttribute('src', src);
        if (textAlign) {
            if (textAlign === 'unset') {
                element.style.textAlign = '';
            } else {
                element.style.textAlign = textAlign;
            }
        }

        // если style пустой, удалить атрибут
        if (element.style.cssText.trim() === '' || NO_STYLES_TAGS.includes(element.tagName.toLowerCase())) {
            element.removeAttribute('style');
        }
    }

    return doc.body.innerHTML;
}
